<template>
  <div class="ai-header">
    <div class="header-content">
      <div class="icon-wrapper">
        <font-awesome-icon :icon="['fas', 'lightbulb']" class="header-icon" />
      </div>
      <span class="header-title">{{ title }}</span>
    </div>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: 'AIHeader',
  props: {
    title: {
      type: String,
      default: 'AI要点速览'
    }
  }
};
</script>

<style scoped>
.ai-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #fbf7ff 0%, #fdfaf9 100%);
}

.header-content {
  display: flex;
  align-items: center;
}

.icon-wrapper {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #4d50e9, #b84fd7, #aa341b);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.header-icon {
  color: #fff;
  font-size: 16px;
}

.header-title {
  font-size: 16px;
  color: #000;
}
</style>
